<app-view-title Title="{{ 'Intellitrailer.Booking.UncofirmedBooking.TitleBookingInformation' | translate : 'Booking information' }}" [isPrimaryColor]="true"></app-view-title>
<view-content [centered]="true" (scroll)="onScroll($event)">
    <app-booking-summary [confirmed]="false"
                         (addableTypesChanged)="updateAddons($event)"
                         [editingExistingBooking]="this.bookingState.existingBooking"
                         [booking]="bookingState.booking"
                         (bookingChange)="bookingUpdatedFromSummary($event)"
                         [atLocation]="bookingState.atLocation"
                         (changeSavedCard)="toggleSavedCard($event)"
                         (changeTerms)="toggleTerms($event)"
                         (changePrice)="updatePrice($event)"
                         [addonsFromPopup]="addonsFromPopup"
                         (sendNext)="goNext()"
                         (specialConditionChanged)="updateSpecialCondition($event)">
    </app-booking-summary>
    <div style="height: 90px"></div>
</view-content>
<view-actions mode="white">
  @if(!bookingState.existingBooking && !terms) {
  <button mat-raised-button class="wide" (click)="prepareForNext()" [disabled]="!scrolledToBottom || !terms">
    {{ 'Intellitrailer.Navigation.Scroll' | translate : 'Scroll down and confirm' }}
  </button>
  }
  @if(!this.bookingState.existingBooking && terms) {
  <button mat-raised-button (click)="prepareForNext()" [disabled]="!terms || !specialConditionApproved || !scrolledToBottom">
    {{ 'Intellitrailer.Navigation.Confirm' | translate : 'Confirm' }} ({{ currentPrice.DiscountedTotalPrice | currency }})
  </button>
  }
  @if(this.bookingState.existingBooking && !terms) {
  <button mat-raised-button (click)="prepareForNext()" [disabled]="!scrolledToBottom">
    {{ 'Intellitrailer.Navigation.Scroll' | translate : 'Scroll down and confirm' }}
  </button>
  }
  @if(this.bookingState.existingBooking && terms) {
  <button mat-raised-button (click)="prepareForNext()" [disabled]="!terms">
    {{ 'Intellitrailer.Navigation.SaveChanges' | translate : 'Save changes' }}
  </button>
  }

</view-actions>

